// 根据产品code，显示不同的保单查询地址
export default {
  XSAIGHSB2022C: 'https://xinbao1.gmfs.cn/index/agentLogin'
};
